import '@plone/volto/config';

const applyConfig = (config) => {
  return config;
};

export default applyConfig;
